import PageHeader from '@/components/page-header';
import ConnectionCard from '@/pages/apps/connections/components/connection-card';
import type { AppShell, ConnectionOption } from '@/types/platform';

interface Props {
  app: AppShell;
  options: ConnectionOption[];
  canManage: boolean;
}

const Index = ({ app, options, canManage }: Props) => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Connections"
        description="Connect the accounts this app uses to take payments and keep your books."
      />

      {app.paymentMode === 'test' ? (
        <p className="text-muted-foreground text-sm">
          Payments are in test mode. No real card is charged.
        </p>
      ) : null}

      <div className="grid gap-4 lg:grid-cols-2">
        {options.map((option) => (
          <ConnectionCard
            key={option.provider}
            appId={app.id}
            option={option}
            canManage={canManage}
          />
        ))}
      </div>
    </div>
  );
};

export default Index;
